(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
 * Name        : DFA Toggle Empty Parent
 * Version     : 1.0.0
 * Author      : Deep Fried
 * Author URL  : https://deepfried.com
 * Description : Setup toggle functionality for custom parent nav link with no page
*/
function toggleSubMenu() {
  var toggle = this.nextElementSibling;
  var hasSubMenuToggle = 'undefined' !== typeof toggle && toggle.classList.contains('menu-item-has-children-toggle');

  if ("#" !== this.getAttribute('href') || !hasSubMenuToggle) {
    return;
  }

  toggle.click();
}

var _default = function _default() {
  var parentNavItems = document.querySelectorAll('.df-nav--primary .menu-item-has-children');
  parentNavItems.forEach(function (parentNavItem) {
    var link = parentNavItem.querySelector('a');
    link.addEventListener('click', toggleSubMenu);
  });
};

exports["default"] = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$window = exports.$navButton = exports.$htmlAndBody = exports.$html = exports.$document = exports.$body = exports.$ = void 0;

/*
 * Name        : DFA Module
 * Version     : 0.3.4
 * Author      : Deep Fried
 * Author URL  : https://deepfried.com
 * Description : Establish some constants for use inside other modules.
*/
var $ = jQuery;
exports.$ = $;
var $document = $(document);
exports.$document = $document;
var $window = $(window);
exports.$window = $window;
var $html = $('html');
exports.$html = $html;
var $body = $('body');
exports.$body = $body;
var $htmlAndBody = $html.add($body);
exports.$htmlAndBody = $htmlAndBody;
var $navButton = $('.js--nav-button');
exports.$navButton = $navButton;

},{}],3:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _nav = _interopRequireDefault(require("./deep-fried-modules/_nav"));

var _navSubmenuToggles = _interopRequireDefault(require("./deep-fried-modules/_navSubmenuToggles"));

var _navToggleEmptyParent = _interopRequireDefault(require("./_navToggleEmptyParent"));

var _snackbar = _interopRequireDefault(require("./deep-fried-modules/_snackbar"));

// import { fetch as fetchPolyfill } from 'whatwg-fetch';
// import WebFontConfig from './_webFonts';
// import chooseRandom from './deep-fried-utilities/_chooseRandom';
// import setupElemInView from './deep-fried-utilities/_elemInView';
// import finalEvent from './deep-fried-utilities/_finalEvent';
// import './deep-fried-utilities/_polyfills';
// import setupRetinaAssets from './deep-fried-utilities/_retina';
// import setupACFGoogleMaps from './deep-fried-modules/_acfGoogleMaps';
// import setupBackToTop from './deep-fried-modules/_backToTop';
// import setupSlider from './components/_slider';
jQuery(document).ready(function () {
  (0, _nav["default"])();
  (0, _navSubmenuToggles["default"])();
  (0, _navToggleEmptyParent["default"])();
  (0, _snackbar["default"])(); // setupElemInView();
  // setupBackToTop();
  // setupRetinaAssets();
  // setupACFGoogleMaps();
  // setupSlider();
}); // window.WebFontConfig = WebFontConfig; // Expose as global variable for webfont loader JS

},{"./_navToggleEmptyParent":1,"./deep-fried-modules/_nav":4,"./deep-fried-modules/_navSubmenuToggles":5,"./deep-fried-modules/_snackbar":6,"@babel/runtime/helpers/interopRequireDefault":7}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _var = require("../_var");

/*
 * Name        : DFA Nav Module
 * Version     : 0.4.7
 * Author      : Deep Fried
 * Author URL  : https://deepfried.com
 * Description : Adds click event listeners to `.Nav a`
*/
var $nav = (0, _var.$)('.df-nav--primary');
/* eslint-disable func-names */

var _default = function _default() {
  // Handle: a[href="#"]
  $nav.on('click', 'a', function (event) {
    if ('#' === (0, _var.$)(this).attr('href')) {
      event.preventDefault();
    }
  }); // Nav Button

  _var.$navButton.on('click', function () {
    _var.$html.toggleClass('df-nav--is-open');
  });
};
/* eslint-enable func-names */


exports["default"] = _default;

},{"../_var":2}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
 * Name        : DFA Sub-menu Toggles
 * Version     : 0.1.0
 * Author URL  : https://deepfried.com
 * Description : Setup Sub-menu Toggles
*/
// Creates and inserts sub-menu toggles
var _default = function _default() {
  var submenuLinks = document.querySelectorAll('.df-nav--primary > .menu-item-has-children');
  submenuLinks.forEach(function (submenuLink) {
    var toggleSwitch = document.createElement('span');
    var submenu = submenuLink.querySelector('.sub-menu');
    toggleSwitch.classList.add('menu-item-has-children-toggle');
    submenuLink.insertBefore(toggleSwitch, submenu);
    var toggle = submenuLink.querySelector('.menu-item-has-children-toggle');
    var parentContainer = toggle.parentNode;
    toggle.addEventListener('click', function () {
      if (parentContainer.classList.contains('is-active')) {
        parentContainer.classList.remove('is-active');
      } else {
        parentContainer.classList.add('is-active');
      }
    });
  });
};

exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
 * Name        : Snackbar
 * Version     : 0.1.1
 * Author      : Deep Fried
 * Author URL  : https://deepfriedads.com
 * Description : Adds local cookie and manages snackbar visibility
*/
var _default = function _default() {
  var html = document.querySelector('html');
  var snackBar = document.querySelector('.df-snackbar');
  var closeSnackBar = document.querySelector('.df-snackbar__close');
  var cookieID = snackBar ? snackBar.dataset.cookie : '';

  function setSnackbarCookie() {
    localStorage.setItem('snackbar', cookieID);
  }

  function hideSnackbar() {
    html.classList.remove('df-snackbar-is-visible');
  } // Check browser support


  if ('undefined' !== typeof Storage) {
    if (cookieID === localStorage.getItem('snackbar')) {
      html.classList.remove('df-snackbar-is-visible');
    } else {
      html.classList.add('df-snackbar-is-visible');
    }

    if (snackBar) {
      closeSnackBar.addEventListener('click', hideSnackbar);
      closeSnackBar.addEventListener('click', setSnackbarCookie);
    }
  }
};

exports["default"] = _default;

},{}],7:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}]},{},[3]);
